var map = {
	"./ball-dark.svg": "d907",
	"./ball-light.svg": "b2f8",
	"./ball-regular.svg": "3430",
	"./ball.svg": "b530",
	"./berry.svg": "b703",
	"./blue-leaf.svg": "553b",
	"./branch.svg": "f02c",
	"./branched-log.svg": "b7f7",
	"./brown-leaf.svg": "35f8",
	"./brown-treetop.svg": "992c",
	"./fat-stalk.svg": "b668",
	"./four-leaves.svg": "ac24",
	"./green-leaf-branch.svg": "1150",
	"./green-treetop.svg": "6150",
	"./leaf-branch.svg": "f2df",
	"./leaf-light.svg": "01f8",
	"./leaf.svg": "924c",
	"./log.svg": "bf93",
	"./main-log.svg": "47d3",
	"./root.svg": "105b",
	"./seed.svg": "c43b",
	"./stalk-medium.svg": "9ae3",
	"./stalk-top.svg": "1d4d",
	"./stalk.svg": "e903",
	"./sub-branch.svg": "8a4d",
	"./subroot-left.svg": "2a4a",
	"./subroot.svg": "3fa4",
	"./treetop.svg": "e7d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d58";